import {SortDirection} from 'src/openapi/admin/models/SortDirection';

import type {ColumnAdapter, ColumnOrder} from 'src/components/edit-columns/column-adapter';

export const PLATFORM_COLUMN = 'PLATFORM';
export const PLATFORM_COLUMN_ID = 'platform';

const isPlatformSource = (code: string) => code === 'TYPE' || code === 'STATUS';
const orderedCodes = (columns: ColumnOrder) => Object.keys(columns).sort((a, b) => columns[a] - columns[b]);
const columnOrder = (codes: string[]): ColumnOrder => Object.fromEntries(codes.map((code, index) => [code, index]));

export const platformColumnAdapter: ColumnAdapter = {
    toDisplay: columns => columnOrder([...new Set(orderedCodes(columns)
        .map(code => isPlatformSource(code) ? PLATFORM_COLUMN : code))]),
    toStored: (columns, previousColumns) => {
        const previousSources = orderedCodes(previousColumns).filter(isPlatformSource);
        const sources = previousSources.length ? previousSources : ['TYPE', 'STATUS'];
        return columnOrder(orderedCodes(columns).flatMap(code => code === PLATFORM_COLUMN ? sources : [code]));
    },
    getSorting: (column, direction) => isPlatformSource(column)
        ? {column: 'EMAIL', direction: SortDirection.ASC}
        : {column, direction},
};

export const projectPlatformColumnIds = (ids: string[], enabled: boolean): string[] => enabled
    ? [...new Set(ids.map(id => id === 'type' || id === 'status' ? PLATFORM_COLUMN_ID : id))]
    : ids;

export const formatPlatformValue = (type: string, status: string) => `${type}: ${status}`;
